const STABLE = "stable_version";
const TESTING = "testing_version";

const ALL = [STABLE, TESTING];

export { ALL, STABLE, TESTING };
